import { Grid } from "@mui/material";
import ManageBalanceModal from "../../../../../Components/Molecules/ManageBalanceModal";
import { isDevelopmentOnly } from "../../../../../Utils/developmentFeature";
import AddAmountIcon from "@mui/icons-material/AddBusiness";
import SaqueAmountIcon from "@mui/icons-material/PointOfSale";
import CustomButton from "../../CustomButton";
import SaldoCard from "../SaldoCard";

type Props = {
  name: string;
  available: number;
  subAccountId: string;
};

const ResumoSection = ({ name, available, subAccountId }: Props) => (
  <Grid container>
    <Grid container marginBottom="12px">
      <SaldoCard title={"Saldo do ponto de venda"} name={name} amount={available} />
    </Grid>
    {isDevelopmentOnly && (
      <ManageBalanceModal pointSaleName={name} pointSaleAmount={available} subAccountId={subAccountId}>
        {({ handleOpenModal }) => (
          <Grid container spacing={2}>
            <Grid item>
              <CustomButton startIcon={<AddAmountIcon />} onClick={() => handleOpenModal("add-amount")}>
                Adicionar valor
              </CustomButton>
            </Grid>
            <Grid item>
              <CustomButton startIcon={<SaqueAmountIcon />} onClick={() => handleOpenModal("withdraw-amount")}>
                Resgatar valor
              </CustomButton>
            </Grid>
          </Grid>
        )}
      </ManageBalanceModal>
    )}
  </Grid>
);

export default ResumoSection;
